import { render, staticRenderFns } from "./unit-firmware.vue?vue&type=template&id=65f87e56&"
import script from "./unit-firmware.vue?vue&type=script&lang=js&"
export * from "./unit-firmware.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports